<template>
  <div class="goods-type-page">
    <el-row>
      <div class="toolbar">
        <el-button @click="onSaveGoodsType" type="primary" :disabled="loading">保 存</el-button>
      </div>
    </el-row>

    <el-row class="mb-1" v-loading="loading">
      <el-tooltip class="item" effect="dark" content="添加同一级" placement="top-start">
        <el-button @click="onAddNextType" type="primary" size="small"> <i class="sy-icon-chklist"></i> </el-button>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="添加下一级" placement="top-start">
        <el-button @click="onAddChildType" type="primary" size="small"> <i class="sy-icon-list"></i> </el-button>
      </el-tooltip>
    </el-row>
    <el-row :gutter="10" v-loading="loading">
      <el-col :span="12">
        <el-input class="mb-2" placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
        <el-tree class="filter-tree" :data="typeDatas" node-key="type_code" :expand-on-click-node="false" :props="defaultProps" default-expand-all draggable highlight-current :filter-node-method="filterNode" ref="typeTree" @current-change="onTypeSelected">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span><el-button type="text" size="mini" @click="() => removeNode(node, data)"><i class="el-icon el-icon-close"></i></el-button></span>
          </span>
        </el-tree>
      </el-col>
      <el-col :span="12">
        <el-form v-if="selType != null" label-width="80px" :model="selType" :rules="rules" ref="typeForm">
          <el-form-item label="编码" prop="label">
            <span>{{selType.type_code}}</span>
          </el-form-item>
          <el-form-item label="名称" prop="label">
            <el-input v-model="selType.label" placeholder="输入名称"></el-input>
          </el-form-item>
          <el-form-item label="图片" prop="imgurl">
            <el-upload class="img-uploader" action="./sys/files/upload" :show-file-list="false" :data="uploadData" :on-success="onImgSuccess" :before-upload="beforeImgUpload">
              <img v-if="selType.imgurl" :src="typeImgUrl" class="img">
              <i v-else class="el-icon-plus img-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {getGoodsTypeTree, saveGoodsTypes} from '../../api/goods_type'
import {getGuid, appConfig, isNullOrEmpty} from '../../api/utils'

export default {
  data() {
    return {
      filterText:"",
      typeDatas:[],
      loading:false,
      selType:null,
      typeImgUrl:"",
      rules:{
        TypeName:[{ required: true, message: '请输入说明', trigger: 'blur' }],
        TypeCode:[{ required: true, message: '请输入分类编码', trigger: 'blur' }],
        SetName:[{ required: true, message: '请输入配置名', trigger: 'blur' }]
      },
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      uploadData:{ID:0, Source:'wx', BusType:'class'},
      delTypeList:[],
    };
  },
  created(){
    this.onSearch();
  },
  watch: {
    filterText(val) {
      this.$refs.typeTree.filter(val);
    }
  },
  methods:{
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    onSaveGoodsType:function(){
      this.loading = true
      var saveList = []
      this.getGoodsTypes(saveList, this.typeDatas)
      saveList = saveList.concat(this.delTypeList)
      saveGoodsTypes(saveList).then(resp=>{
        this.loading = false
        if (resp.data.code == 100){
          this.$notify.success({title: '成功',message: '保存成功'})
          this.onSearch()
        }else{
          this.$notify.error({title: '失败',message: resp.data.msg})
        }
      },err=>{
        this.$notify.error({title:'保存失败',message:err.statusText})
        this.loading = false
      });
    },
    onSearch:function(){
      this.loading = true
      this.delTypeList = []
      getGoodsTypeTree().then(resp=>{
        this.loading = false
        if (resp.data.code == 100){
          this.typeDatas = resp.data.data||[];
        }else{
          this.$notify.error({title: '失败',message: "加载数据失败：" + resp.data.msg})
        }
      },err=>{
        this.loading = false
        this.$notify.error({title:'查询失败',message:err.statusText})
      });
    },
    onTypeSelected:function(selNode){
      this.selType = selNode;
      if (!isNullOrEmpty(this.selType.imgurl)){
        this.typeImgUrl = appConfig.file_path + this.selType.imgurl
      }
    },
    onAddNextType:function(){
      var selNode = this.$refs.typeTree.getCurrentNode();
      var newNode = {id:0, label:'New Node', type_code:'tmp:' + getGuid(), parent_code:'', imgurl:'', enable:1, children: null};
      if (selNode == null){
        this.typeDatas.push(newNode);
      }else{
        var pNode = this.$refs.typeTree.getNode(selNode.parent_code)
        if (pNode != null)pNode = pNode.data
        if (pNode == null)return
        newNode.parent_code = pNode.type_code
        if (pNode.children == null){
          pNode.children = [newNode]
        }else{
          pNode.children.push(newNode)
        }
      }
    },
    onAddChildType:function(){
      var selNode = this.$refs.typeTree.getCurrentNode();
      var newNode = {id:0, label:'New Node', type_code:'tmp:' + getGuid(), parent_code:'', imgurl:'', enable:1, children: null};
      if (selNode != null){
        newNode.parent_code = selNode.type_code
        if (selNode.children == null){
          selNode.children = [newNode]
        }else{
          selNode.children.push(newNode)
        }
      }
    },
    getGoodsTypes(gList, dataList){
      for(var i = 0; i < dataList.length; i++){
        var newType = { ID: dataList[i].id, TypeCode: dataList[i].type_code, TypeName: dataList[i].label, ParentTypeCode: dataList[i].parent_code, ImgUrl: dataList[i].imgurl, EnableFlag: dataList[i].enable}
        gList.push(newType)
        if (dataList[i].children && dataList[i].children.length > 0){
          this.getGoodsTypes(gList, dataList[i].children)
        }
      }
      return gList;
    },
    onImgSuccess(res, file) {
      if (res.code == 100) {
        this.selType.imgurl = res.data.FilePath;
        this.typeImgUrl = appConfig.file_path + this.selType.imgurl
      }
    },
    beforeImgUpload(file){
      const isJPG = (file.type === 'image/jpeg' || file.type === 'image/png');
      const isLt2M = file.size / 100 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 100KB!');
      }
      return isJPG && isLt2M;
    },
    removeNode(node, data) {
      const parent = node.parent;
      const children = parent.data.children || parent.data;
      const index = children.findIndex(d => d.id === data.id);
      const dNode = children[index];
      if (!confirm("是否删除类别["+dNode.label+"]"))return;
      this.delTypeList.push({ID: dNode.id, TypeCode: dNode.type_code, TypeName: dNode.label, ParentTypeCode: dNode.parent_code, ImgUrl: dNode.imgurl, EnableFlag: 0})
      children.splice(index, 1);
      return false;
    }
  }
}
</script>
<style lang="scss" scoped>
.goods-type-page{
  .toolbar{margin-bottom: 10px;}
  .mb-1{margin-bottom: 5px;}
  .mb-2{margin-bottom: 10px;}
  .img-uploader /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .img-uploader /deep/ .el-upload:hover {
    border-color: #409EFF;
  }
  .img-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 64px;
    height: 64px;
    line-height: 64px;
    text-align: center;
  }
  .img {
    width: 64px;
    height: 64px;
    display: block;
  }
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/goods/goods_type.vue